<template>
	<v-dialog v-model="dialogAddProject" transition="scroll-x-reverse-transition" max-width="850">
		<template #activator="{ on, attrs }">
			<v-btn
				color="success"
				class="font-weight-bold"
				elevation="0"
				dark
				rounded
				v-bind="attrs"
				v-on="on">
				<v-icon left>mdi-account-plus-outline</v-icon>
				New Project
			</v-btn>
		</template>
		<template #default>
			<v-card>
				<v-card-title>
					<div>Create Project</div>
					<v-icon right class="ml-auto theme--dark" @click="dialogAddProject = false">mdi-close</v-icon>
				</v-card-title>
				<v-divider class="mb-5" />
				<v-card-text>
					<project-form :client="client" @success="dialogAddProject = false" />
				</v-card-text>
			</v-card>
		</template>
	</v-dialog>
</template>
<script>
import Backend from '@/Layouts/Backend'
import ProjectForm from '@/Pages/Backend/Projects/Form'

export default {
	components: { ProjectForm },
	layout: Backend,
	props: {
		client: {
			type: Object,
			required: false,
			default: null
		}
	},
	data () {
		return {
			types: [],
			dialogAddProject: false
		}
	},
	mounted () {
		//
	},
	methods: {
		//
	}
}
</script>
